import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';
import {
 Control,
 Controller,
 FieldErrors,
 UseFormSetValue,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import SelectApi from '../../common/SelectApi';
import { WidgetProductStockProps } from '../Dashboard.types';

interface ProductStockFiltersProps {
 control: Control<WidgetProductStockProps>;
 setValue: UseFormSetValue<WidgetProductStockProps>;
 errors: FieldErrors<WidgetProductStockProps>;
}

const ProductStockFilters: React.FC<ProductStockFiltersProps> = ({
 control,
 setValue,
 errors,
}) => {
 const { t } = useTranslation();
 const productFilter = JSON.stringify({ fields: 'Id,Name' });
 const destPointFilter = JSON.stringify({ fields: 'Id,Name' });
 const destPointGroupFilter = JSON.stringify({ fields: 'Id,Name' });

 return (
  <>
   <SelectApi<WidgetProductStockProps>
    name="fromDestPoint"
    url="/api/DestPoint/v1/"
    filter={destPointFilter}
    label={t('dashboard.filters.fromDestPoint')}
    isEditable
    operator="contains"
    control={control}
    setValue={setValue}
   />
   <SelectApi<WidgetProductStockProps>
    name="products"
    url="/api/Products/v2/"
    filter={productFilter}
    label={t('dashboard.filters.products')}
    isEditable
    operator="contains"
    control={control}
    setValue={setValue}
   />
   <SelectApi<WidgetProductStockProps>
    name="toDestPoint"
    url="/api/DestPoint/v1/"
    filter={destPointFilter}
    label={t('dashboard.filters.toDestPoint')}
    isEditable
    operator="contains"
    control={control}
    setValue={setValue}
   />
   <SelectApi<WidgetProductStockProps>
    name="toDestPointGroups"
    url="/api/DestPoint/v1/groups"
    filter={destPointFilter}
    label={t('dashboard.filters.toDestPointGroups')}
    isEditable
    operator="contains"
    control={control}
    setValue={setValue}
    multiple
   />
   <FormControl fullWidth>
    <InputLabel id="sort-order-label">{t('dashboard.filters.sortOrder')}</InputLabel>
    <Controller
     name="sortOrder"
     control={control}
     render={({ field }) => (
      <Select
       {...field}
       labelId="sort-order-label"
       id="sort-order"
       label={t('dashboard.filters.sortOrder')}
       value={field.value || 'desc'}
      >
       <MenuItem value="desc">{t('dashboard.filters.descending')}</MenuItem>
       <MenuItem value="asc">{t('dashboard.filters.ascending')}</MenuItem>
      </Select>
     )}
    />
   </FormControl>
  </>
 );
};

export default ProductStockFilters;
